import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

import useCheckHistory from "../../hooks/useCheckHistory";
import { BackIcon } from "../../utils/iconRefs/recipeStepsIcons";
import styles from "./recipeReviewPage.module.css";

const RecipeReviewPageSkeleton = () => {
  const goBackOrRedirect = useCheckHistory();

  const handleBackClick = () => goBackOrRedirect('/');

  return (
    <Grid className={styles.reviews_container}>
      <AppBar className={styles.nav}>
        <Grid className={styles.back_arrow} onClick={() => handleBackClick()}>
          <BackIcon />
        </Grid>
        <Skeleton className={styles.ratings_summary_skeleton} variant="text" />
        <Grid className={styles.review_back_button} />
      </AppBar>
      <Grid className={styles.reviews_below_appbar}>
        <Grid className={styles.ratings_summary_skeleton_container}>
          <Skeleton className={styles.ratings_summary_skeleton} variant="text" />
          <Skeleton className={styles.ratings_summary_card_skeleton} variant="rounded" />
        </Grid>

        <Grid>
          <Skeleton className={styles.ratings_summary_skeleton} variant="text" />
          <Grid className={styles.recent_ratings_card_skeleton_container}>
            <Skeleton className={styles.recent_ratings_card_skeleton} variant="rounded" />
            <Skeleton className={styles.recent_ratings_card_skeleton} variant="rounded" />
            <Skeleton className={styles.recent_ratings_card_skeleton} variant="rounded" />
            <Skeleton className={styles.recent_ratings_card_skeleton} variant="rounded" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default RecipeReviewPageSkeleton;